import { render, staticRenderFns } from "./PasswordChanged.vue?vue&type=template&id=01dee31b"
import script from "./PasswordChanged.vue?vue&type=script&lang=js"
export * from "./PasswordChanged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports